import { render, staticRenderFns } from "./DiagHeaderNavigation.vue?vue&type=template&id=355fd608&scoped=true&"
import script from "./DiagHeaderNavigation.vue?vue&type=script&lang=js&"
export * from "./DiagHeaderNavigation.vue?vue&type=script&lang=js&"
import style0 from "./DiagHeaderNavigation.vue?vue&type=style&index=0&id=355fd608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355fd608",
  null
  
)

export default component.exports